
import React from 'react';
// Fix: Import Page type from correct location
import { Page } from '../types';
import { SITE_CONTENT } from '../constants/content';

interface FeaturesProps {
  navigate: (page: Page) => void;
}

const Features: React.FC<FeaturesProps> = ({ navigate }) => {
  return (
    <div className="container mx-auto px-4 md:px-6">
      <div className="flex flex-col md:flex-row items-center justify-between mb-16 gap-8">
        <div className="max-w-xl">
          <h2 className="text-3xl md:text-5xl font-extrabold text-secondary mb-4">
            Funktionen der <br /><span className="text-primary italic">Zukunft</span>
          </h2>
          <p className="text-gray-600 text-lg">
            Wir kombinieren modernste App-Technologie mit didaktisch wertvollem Wissen. Eine Vorschau auf das, was kommt.
          </p>
        </div>
        <button 
          // Changed from 'features' to 'funktionen' to match the Page type definition
          onClick={() => navigate('funktionen')}
          className="bg-secondary text-white px-8 py-4 rounded-2xl font-bold hover:bg-secondary/90 transition-all shadow-lg active:scale-95 text-sm"
        >
          Alle Features entdecken
        </button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
        {SITE_CONTENT.features.map((f, i) => (
          <div key={i} className="group relative">
            <div className={`rounded-[2.5rem] overflow-hidden mb-6 shadow-sm h-60 border border-gray-100 flex items-center justify-center transition-all duration-500 group-hover:shadow-xl ${f.bg}`}>
              <div className="text-7xl group-hover:scale-110 transition-transform duration-500" aria-hidden="true">
                {f.icon}
              </div>
              
              <div className="absolute top-4 right-4 bg-white/90 backdrop-blur px-3 py-1.5 rounded-full text-[10px] font-black text-secondary shadow-sm border border-gray-100 uppercase tracking-widest">
                {f.status}
              </div>
            </div>
            
            <h3 className="text-2xl font-bold text-secondary mb-3 group-hover:text-primary transition-colors">{f.title}</h3>
            <p className="text-gray-500 leading-relaxed text-sm">
              {f.desc}
            </p>
          </div>
        ))}
      </div>
      
      <div className="mt-16 text-center text-xs text-gray-400 italic">
        Hinweis: Die dargestellten Inhalte und Designs können sich bis zum Release noch verändern.
      </div>
    </div>
  );
};

export default Features;
